import { BaseModel } from '~/models/baseModel';

export class UserPreferenceModel<T> extends BaseModel {
    public key:string;
    public value:T;
    public userPreferenceId:number;
}
